import React, {useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify'; // Optional: for showing errors or success messages
import { CommonPage } from '../components/common/CommonPage';
import { CmsContext } from '../context/CmsContext';

export const Aboutus = () => {
  const { cmsData, loading } = useContext(CmsContext);
  return (
    <div>
      <CommonPage pageTitle={"About us"} ckData={cmsData.aboutUs} loading={loading} />
    </div>
  )
};
